import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  OnChanges,
  effect,
  inject,
} from "@angular/core";
import { BilledOrdersYtdResponse } from "../../../../core/models/dashboard-poc/billedOrdersYtdResponse";
import { DashbaordPocAdditionalFilters } from "../../../../core/models/common/dashboardPocAdditionalFilters.dto";
import { SharedService } from "../../../../core/services/shared.service";
import { ChartModule } from "primeng/chart";
import { CommonModule } from "@angular/common";

@Component({
  selector: "jni-billed-orders-ytd-chart",
  templateUrl: "./billed-orders-ytd-chart.component.html",
  styleUrls: ["./billed-orders-ytd-chart.component.scss"],
  imports: [ChartModule, CommonModule],
})
export class BilledOrdersYtdChartComponent implements OnInit, OnChanges {
  @Input() billedOrdersYTD: BilledOrdersYtdResponse[] = [];

  @Input()
  dashbaordPocAdditionalFilters: DashbaordPocAdditionalFilters =
    {} as DashbaordPocAdditionalFilters;

  @Input() fromComponent = "";

  @Output() closeSalesOrderModel = new EventEmitter<true>();
  @Output() openOrderListingModal = new EventEmitter<boolean>();

  data!: {
    labels: string[];
    datasets: [
      {
        type: string;
        label: string;
        backgroundColor: string;
        data: number[];
      },
      {
        type: string;
        label: string;
        backgroundColor: string;
        data: number[];
      },
    ];
  };
  options!: {
    maintainAspectRatio: boolean;
    aspectRatio: number;
    plugins: {
      tooltips: {
        mode: string;
        intersect: boolean;
      };
      legend: {
        labels: {
          color: string;
        };
      };
    };
    scales: {
      x: {
        stacked: boolean;
        ticks: {
          color: string;
        };
        grid: {
          color: string;
          drawBorder: boolean;
        };
      };
      y: {
        stacked: boolean;
        ticks: {
          color: string;
        };
        grid: {
          color: string;
          drawBorder: boolean;
        };
      };
    };
  };

  orderListingDisplayModal = false;
  bgColor!: string;
  private sharedService = inject(SharedService);

  constructor(private _sharedService: SharedService) {
    effect(() => {
      const currentTheme = this.sharedService.getTheme()();
      this.bgColor = currentTheme === "dark" ? "#212630" : "#FFFFFF";
      this.ngOnInit();
      // const documentStyle = getComputedStyle(document.documentElement);
      // this.textColor = documentStyle.getPropertyValue("--p-h2color-color");
      // this.options.plugins.legend.labels.color = this.textColor;
      // this.updateChartOptions();
    });
  }

  ngOnChanges(): void {
    this.ngOnInit();
  }

  closeOrderListingModal() {
    this.closeSalesOrderModel.emit(true);
    this.orderListingDisplayModal = false;
    this.openOrderListingModal.emit(false);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  selectData(obj: any) {
    const selectedIndex = obj.element.datasetIndex;
    const selectedColumnNumber = obj.element.index;
    const rowdetails = this.billedOrdersYTD[selectedColumnNumber];
    // const getDates = this.getFromDateToDateFromIndex(
    //   rowdetails
    // );
    
    const saleOrderIdList = selectedIndex == 1
      ? rowdetails.paidSalesOrderIdList
      : rowdetails.openSalesOrderIdList;
    
    // Get existing filter object to preserve the date range
    const existingFilters = this._sharedService.getDashbaordPocAdditionalFiltersObject();
    
    const dashbaordPocAdditionalFilters: DashbaordPocAdditionalFilters = {
      additionalFilters: true,
      bacNumber:
        this.fromComponent == "bac-report"
          ? existingFilters?.brandingConsultant
          : "",
      brandingConsultant:
        this.fromComponent == "bac-report"
          ? ""
          : existingFilters?.brandingConsultant,
      // Preserve existing date range instead of overwriting with today's date
      fromDate: existingFilters?.fromDate ?? this.formatDateToISO(new Date().toDateString()),
      toDate: existingFilters?.toDate ?? this.formatDateToISO(new Date().toDateString()),
      status: "All",
      dashboardSalesOrderId: saleOrderIdList,
      isSimpleOrderSearch: saleOrderIdList && saleOrderIdList.length > 0,
      orderCreatedDateFilterCriteria: existingFilters?.orderCreatedDateFilterCriteria ?? "",
      applyNonAdminRules: existingFilters?.applyNonAdminRules ?? false,
      brandingConsultantNumber: existingFilters?.brandingConsultantNumber ?? "",
      isInventorySales: existingFilters?.isInventorySales ?? false,
    } as DashbaordPocAdditionalFilters;
    this._sharedService.setDashbaordPocAdditionalFiltersObject(
      dashbaordPocAdditionalFilters
    );

    this.orderListingDisplayModal = true;
    this.openOrderListingModal.emit(true);

    // this._router.navigate(['orders/orderslist/1']);
  }

  // getFromDateToDateFromIndex(rowdetails: any) {
  //   const currentDate = new Date(
  //     rowdetails.year,
  //     this.getMonthFromString(rowdetails.month) + 1,
  //     0
  //   );
  //   const lastDayOfMonth = new Date(
  //     rowdetails.year,
  //     this.getMonthFromString(rowdetails.month) + 1,
  //     0
  //   );
  //   const obj: any = {
  //     fromDate: `${currentDate.getMonth()}/1/${rowdetails.year}`,
  //     toDate: `${currentDate.getMonth() + 1}/${lastDayOfMonth.getDate()}/${
  //       rowdetails.year
  //     }`
  //   };
  //   return obj;
  // }

  // getMonthFromString(mon: any) {
  //   const d = Date.parse(mon + '1, 2012');
  //   if (!isNaN(d)) {
  //     return new Date(d).getMonth() + 1;
  //   }
  //   return -1;
  // }

  ngOnInit() {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue("--p-h2color-color");
    const textColorSecondary =
      documentStyle.getPropertyValue("--p-h2color-color");
    const surfaceBorder = documentStyle.getPropertyValue("--p-h2color-color");

    const labels = this.billedOrdersYTD.map(x => `${x.month} ${x.year}`);

    const openFiltered = this.billedOrdersYTD.map(x => x.openCount);
    const paidFiltered = this.billedOrdersYTD.map(x => x.paidCount);

    this.data = {
      labels: labels,
      datasets: [
        {
          type: "bar",
          label: "Unpaid",
          backgroundColor: "#99cd94",
          data: openFiltered,
        },
        {
          type: "bar",
          label: "Paid",
          backgroundColor: "#53ac49",
          data: paidFiltered,
        },
      ],
    };

    this.options = {
      maintainAspectRatio: false,
      aspectRatio: 0.8,
      plugins: {
        tooltips: {
          mode: "index",
          intersect: false,
        },
        legend: {
          labels: {
            color: textColor,
          },
        },
      },
      scales: {
        x: {
          stacked: true,
          ticks: {
            color: textColorSecondary,
          },
          grid: {
            color: surfaceBorder,
            drawBorder: false,
          },
        },
        y: {
          stacked: true,
          ticks: {
            color: textColorSecondary,
          },
          grid: {
            color: surfaceBorder,
            drawBorder: false,
          },
        },
      },
    };
  }
  private formatDateToISO(dateString: string | undefined): string {
    if (!dateString) return "";

    const date = new Date(dateString);
    return date.toISOString();
  }
}
